<template>
    <v-card>
        <v-layout row wrap style="padding:10px;">
            <v-flex x12 style="">
                <div style="display:flex;align-items:center; color:#355EAB;">
                    <v-btn small icon light color="#355EAB" flat @click="$emit('close')">
                    <v-icon>close</v-icon>
                    </v-btn>
                    <h2 class="fw400 white--blue">Informasi Dashboard</h2>
                </div>
            </v-flex>
        </v-layout>
        <v-container>
          <v-layout row wrap>
            <v-flex xs12 v-for="(item) in list" :key="item.title" style="margin-bottom: 15px;">
              <h3 style="display:flex; align-items:center; margin-bottom:5px;">
                <img :src="item.icon" style="margin-right: 10px;" alt="icon-dash"/>
                {{ item.title }}
              </h3>
              <p style="color:#8E9196;">
                {{ item.description }}
              </p>
            </v-flex>
          </v-layout>
        </v-container>
    </v-card>
</template>
<script>
export default {
  name: 'info-dialog',
  props: {
    list: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
      infos: []
      // [
      //   {
      //     title: 'Tryout Dikerjakan',
      //     content: 'Jumlah tryout dan ujian yang sudah kamu kerjakan berdasarkan pilihan tryout yang kamu pilih sesuai dengan filter yang dipilih',
      //     src: require('@/assets/icon/achievement/ic_summary_tryout.svg')
      //   },
      //   {
      //     title: 'Rata-Rata Hasil TPS',
      //     content: 'Nilai rata-rata dari semua hasil tryout dan ujian yang sudah kamu kerjakan sesuai dengan filter yang dipilih',
      //     src: require('@/assets/icon/achievement/ic_infohasiltps.svg')
      //   },
      //   {
      //     title: 'Perkembangan TO IPA',
      //     content: 'Perbandingan nilai rata-rata (TPS dan TKA) Tryout atau Ujian terakhir dengan nilai rata-rata Tryout atau Ujian kamu sebelumnya',
      //     src: require('@/assets/icon/achievement/ic_infotoipa.svg')
      //   },
      //   {
      //     title: 'Perkembangan TO IPS',
      //     content: 'Perbandingan nilai rata-rata (TPS dan TKA) Tryout atau Ujian terakhir dengan nilai rata-rata Tryout atau Ujian kamu sebelumnya',
      //     src: require('@/assets/icon/achievement/ic_infotoips.svg')
      //   },
      //   {
      //     title: 'Rata-Rata TKA SAINTEK',
      //     content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ac interdum tortor eget at ornare aliquet mollis. Luctus purus in diam turpis semper.',
      //     src: require('@/assets/icon/achievement/ic_infosaintek.svg')
      //   },
      //   {
      //     title: 'Rata-Rata TKA SOSHUM',
      //     content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu magna mauris eros cras. Sed vulputate diam purus turpis nulla sed eu adipiscing.',
      //     src: require('@/assets/icon/achievement/ic_infososhum.svg')
      //   }

      // ]
    }
  },
  mounted () {
    // this.$store.dispatch('funcGetInfoDashboard').then(response => {
    //   if (response.status === 200) {
    //     // console.log(response)
    //     this.infos = response.data
    //   }
    // })
  }
}
</script>
